import React from 'react';
import { useMessage } from '../messages/useMessage';
import { useJohariService } from '../services/johari-service';

export const useJohariController = () => {
  const {
    getJohariData,
    getJohariInterviewData,
    getJohariInterviewDataPublic,
    saveJohari,
  } = useJohariService();
  const [loading, setLoading] = React.useState(false);
  const { handleError } = useMessage();

  const getJohariDataSteps = React.useCallback(() => {
    setLoading(true);
    return getJohariData()
      .then((data) => data)
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  }, [getJohariData]);

  const saveJohariAnswer = React.useCallback(
    (data) => {
      setLoading(true);
      return saveJohari(data)
        .then((data) => data)
        .catch((error) => {
          throw error;
        })
        .finally(() => setLoading(false));
    },
    [saveJohari],
  );

  const getJohariDataInterview = React.useCallback(
    (id) => {
      setLoading(true);
      return getJohariInterviewData(id)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [getJohariInterviewData],
  );

  const getJohariDataInterviewPublic = React.useCallback(
    (module, cpf) => {
      setLoading(true);
      return getJohariInterviewDataPublic(module, cpf)
        .then((data) => data)
        .catch((error) => {
          handleError(error.message ?? 'Erro ao buscar dados da entrevista!');
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [getJohariInterviewDataPublic, handleError],
  );

  return {
    getJohariDataSteps,
    loading,
    getJohariDataInterview,
    saveJohariAnswer,
    getJohariDataInterviewPublic,
  };
};
